// React imports
import { useOutletContext } from 'react-router-dom';
import { useState } from 'react';

// Generic imports
import axios from 'axios';

// MUI imports
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

function CreateOrganization() {
    const { accesstoken } = useOutletContext();
    const [ thinking, setThinking ] = useState(false);
    const [ alias, setAlias ] = useState('');
    const [ error, setError ] = useState(null);
    const [ success, setSuccess ] = useState(null);

    async function onCreate() {
        setThinking(true);
        setError(null);
        setSuccess(null);

        try {
            const { data } = await axios.post(`/api/organizations/create-organization?accesstoken=${accesstoken}`, { alias });
            setSuccess(alias);
        } catch (error) {
            setError(error?.response?.data?.detail || 'An unknown error occurred');
        }
        setThinking(false);
    }

    return (
        <Box sx={{ mx: 'auto', p: 3, display: 'flex', flexDirection: 'column' }}>
            <Typography variant='h5' sx={{ mb: 2 }}>
                Create Organization
            </Typography>
            <TextField
                label='New organization alias'
                value={alias}
                onChange={(e) => setAlias(e.target.value)}
                sx={{ mb: 2 }}
            />
            {!thinking && (
                <Button onClick={onCreate}>Create</Button>
            )}
            {thinking && (
                <CircularProgress />
            )}
            {success && (
                <Alert severity='success' sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
                    <Typography variant='body1'>
                        Organization created successfully
                    </Typography>
                    <a href={`/organization/${success}`} target='_blank' rel='noreferrer'>View Organization</a>
                </Alert>
            )}
            {error && (
                <Alert severity='error' sx={{ mt: 2 }}>
                    {error}
                </Alert>
            )}
        </Box>
    );
}

export default CreateOrganization;